import { ImageProps, StaticImport } from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import React, { useEffect, useState } from "react";
interface FallbackImageProps extends Omit<ImageProps, "src"> {
  src: string | StaticImport;
  fallbackSrc: string | StaticImport;
  fallbackSrcClassName?: string;
  height?: number | `${number}` | undefined;
  width?: number | `${number}` | undefined;
}

const FallbackImage: React.FC<FallbackImageProps> = ({
  src,
  fallbackSrc,
  fallbackSrcClassName,
  alt = "",
  height,
  width,
  className,
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState<string | StaticImport>(src);
  const [errorOccurred, setErrorOccurred] = useState<boolean>(false);

  const handleError = () => {
    setImageSrc(fallbackSrc);
    setErrorOccurred(true);
  };

  useEffect(() => {
    if (!src) {
      setImageSrc(fallbackSrc);
      setErrorOccurred(true);
    } else {
      setErrorOccurred(false);
      setImageSrc(src);
    }
  }, [src, fallbackSrc]);

  const combinedClassName =
    errorOccurred && fallbackSrcClassName ? fallbackSrcClassName : className;

  return (
    <>
      {/* {JSON.stringify({ src, fallbackSrc })} */}
      <Image
        src={imageSrc}
        alt={alt}
        onError={handleError}
        height={height}
        width={width}
        className={combinedClassName}
        {...props}
      />
    </>
  );
};

export default React.memo(FallbackImage);
